<div class="sp-row__space">
  <div class="sp-row__align">
    <mat-icon
      class="sp-color__primary sp-hidden__before-md sp-cursor__pointer"
      (click)="onBackClick()">
      arrow_back
    </mat-icon>
    <h2 class="sp-margin__left sp-color__primary sp-hidden__before-md">{{ getShrinkedID() }}</h2>
    <h3 class="sp-margin__left sp-color__primary sp-hidden__after-md">{{ getShrinkedID() }}</h3>
  </div>

  <div class="sp-row__align">
    <mat-spinner
      *ngIf="is_read_running"
      color="accent"
      diameter="20"></mat-spinner>

    <app-company-details-navbar
      *ngIf="!is_read_running"
      (tab_change)="tab_change.emit($event)"></app-company-details-navbar>

    <button
      (click)="$event.stopPropagation()"
      mat-icon-button
      class="sp-icon__button sp-icon__button-accent sp-margin__left"
      [matTooltip]="'Menu' | translate"
      [mat-menu-trigger-for]="company_details_actions_menu">
      <mat-icon> more_horiz </mat-icon>
    </button>

    <mat-menu #company_details_actions_menu="matMenu">
      <button
        mat-menu-item
        (click)="onContractClick(); $event.stopPropagation()">
        <mat-icon class="material-symbols-outlined">description</mat-icon>
        <span>{{ 'COMPANIES.CONTRACTS_VIEW_CTA' | translate }}</span>
      </button>

      <button
        mat-menu-item
        (click)="onArchiveClick(); $event.stopPropagation()">
        <mat-icon class="material-symbols-outlined">inventory_2</mat-icon>
        <span>{{ 'COMPANIES.ARCHIVE_CTA' | translate }}</span>
      </button>

      <button
        mat-menu-item
        (click)="onPaymentMethodsClick(); $event.stopPropagation()">
        <mat-icon class="material-symbols-outlined">account_balance</mat-icon>
        <span>{{ 'STORES.PAYMENT_METHODS_LABEL' | translate }}</span>
      </button>

      <button
        (click)="onEnableDisableClick(); $event.stopPropagation()"
        mat-menu-item>
        <mat-icon class="material-symbols-outlined"> do_not_disturb_on </mat-icon>
        <span>{{ 'COMPANIES.ENABLE_DISABLE_CTA' | translate }}</span>
      </button>

      <button
        mat-menu-item
        (click)="onAllowedStepsClick(); $event.stopPropagation()">
        <mat-icon class="material-symbols-outlined">apps</mat-icon>
        <span>{{ 'STORES.ALLOWED_STEPS_LABEL' | translate }}</span>
      </button>
      <button
        mat-menu-item
        (click)="onTicketClick(); $event.stopPropagation()">
        <mat-icon class="material-symbols-outlined">euro</mat-icon>
        <span>{{ 'STORES.TICKET_CTA' | translate }}</span>
      </button>
      <button
        mat-menu-item
        (click)="onEditClick(); $event.stopPropagation()">
        <mat-icon class="material-symbols-outlined">create</mat-icon>
        <span>{{ 'COMPANIES.EDIT_CTA' | translate }}</span>
      </button>
      <button
        mat-menu-item
        (click)="onSettingsClick(); $event.stopPropagation()">
        <mat-icon class="material-symbols-outlined">settings</mat-icon>
        <span>{{ 'STORES.SETTINGS_LABEL' | translate }}</span>
      </button>
      <button
        mat-menu-item
        (click)="onSetCustomDomainClick(); $event.stopPropagation()">
        <mat-icon class="material-symbols-outlined sp-icon__min-width">public</mat-icon>
        <span>{{ 'STORES.CUSTOM_BUYER_SUBDOMAIN_LABEL' | translate }}</span>
      </button>
    </mat-menu>

    <button
      (click)="refresh.emit()"
      mat-icon-button
      [matTooltip]="'GENERAL.REFRESH_CTA' | translate"
      class="sp-icon__button sp-icon__button-dark sp-margin__left">
      <mat-icon class="material-symbols-outlined"> refresh </mat-icon>
    </button>
  </div>
</div>
